import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import BikeOnboardingForm from './BikeOnboardingForm';
import { isJackOnboardingComplete, setJackOnboardingComplete } from '../utils/jackSettings';
import '../App.css';
import './BikeOnboardingPage.css';

const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/logo_shokiq_horizontal.svg`;

function BikeOnboardingPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  if (isJackOnboardingComplete()) {
    return <Navigate to="/home" replace />;
  }

  const goHome = () => navigate('/home', { replace: true });

  return (
    <div className="login-page bike-onboarding-page">
      <img src={LOGO_SRC} alt="ShokIQ" className="login-logo" />
      <BikeOnboardingForm
        variant="page"
        showSkip
        onCompleted={goHome}
        onSkip={() => {
          setJackOnboardingComplete();
          goHome();
        }}
      />
    </div>
  );
}

export default BikeOnboardingPage;
